export const ADMIN_EMAIL = 'ayamatchmaker@gmail.com';

export const isAdminUser = (user) => !!user && user.email === ADMIN_EMAIL;
